import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ProgressIndicator, Pivot, PivotItem, Separator, TooltipHost } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../../../app/Hooks"
import { getPage } from "../../../../../app/Pages"
import { setPage } from "../../../../layouts/Master/MasterLayoutSlice"
import { setTitle } from "../../../../common/NavHeader/NavHeaderSlice"
import { useSetInterval, useConst } from '@fluentui/react-hooks';
import { Table } from "../../../../common/Table/Table"
import { ApiMessage, getHeaders, getSession, PROFILE_LOGO_URL } from "../../../../../app/Api"
import { useId, useBoolean } from '@fluentui/react-hooks';

import { Message } from "../../../../common/Message/Message"
import { ShareBox } from "../../../../common/ShareBox/ShareBox"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { SessionExpiredDialog } from "../../../../common/SessionExpiredDialog/SessionExpiredDialog"
import React from "react"
import { deleteItem, dismissMessage, get, reset, resetItem, updateItem, updateStatus } from "./CurrencyPairDetailsPageSlice"
import { Popup } from "../../../../common/Popup/Popup"
import { FormType } from "../../../../forms/FormProps"
import { DynamicField } from "../../../../common/DynamicFields/DynamicFields"
import { DeleteCurrencyRequest, GetCurrencyRequest } from "../../../../../repository/Accountant/currency_pb"
import { CurrenciesForm } from "../../../../forms/Accountant/Currencies/CurrenciesForm"
import { CurrencyForm } from "../../../../../app/Enums"
import { TextView } from "../../../../common/DataView/TextView"
import { ProfileView } from "../../../../common/DataView/ProfileView"
import { DeleteCurrencyPairRequest, GetCurrencyPairRequest, UpdateCurrencyPairActivityRequest } from "../../../../../repository/Trading/currency_pair_pb"
import { LinkView } from "../../../../common/DataView/LinkView"
import { currencyFormatter, printComponent, normalizeKey } from "../../../../../app/Helpers"
import { CurrencyPairsForm } from "../../../../forms/Trading/CurrencyPairs/CurrencyPairsForm"
import { useReactToPrint } from "react-to-print"
import { CurrencyPairsPriceForm } from "../../../../forms/Trading/CurrencyPairs/CurrencyPairsPriceForm"
import { CurrencyPairPriceChangeLogPage } from "./CurrencyPairPriceChangeLogPage/CurrencyPairPriceChangeLogPage"
import { CurrencyPairsPriceSettingsForm } from "../../../../forms/Trading/CurrencyPairs/CurrencyPairsPriceSettingsForm"


const shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
};


let req: GetCurrencyPairRequest;

let org: number = -1;

let getPromise: any;
let actionPromise: any;


const key = "trading/currencyPairs/details"
export const CurrencyPairDetailsPage: React.FunctionComponent = () => {

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    let { id } = useParams();
    const [selectedKey, setSelectedKey] = useState("0");

    const state: {
        isChangeStateLoading: boolean,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        isLoading: boolean,
        item: any
    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.currencyPairDetailsPage.isChangeStateLoading,
            message: state.currencyPairDetailsPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            isLoading: state.currencyPairDetailsPage.isLoading,
            item: state.currencyPairDetailsPage.item,

        }
    })
    const calloutTargetId = useId('callout-target');
    const labelId = useId('callout-label');
    const deleteActionConfirmationcalloutTargetId = useId('delete-action-callout-target');
    const activityActionConfirmationcalloutTargetId = useId('activity-action-callout-target');
    const ActionConfirmationLabelId = useId('action-callout-label');
    const shareCalloutLabelId = useId('share-callout-label');
    const shareTargetId = useId('share-callout-target');

    const [isActionConfirmationCalloutVisible, { toggle: toggleisActionConfirmationCalloutVisible }] = useBoolean(false);
    const [isShareCalloutVisible, { toggle: toggleisShareCalloutVisible }] = useBoolean(false);

    const [currentAction, setCurrenctAction] = useState(0)
    const { hash } = useLocation();
    const formatTradingHours = (time: any) => {
        const hour = Math.floor(time / 100);
        const minutes = time % 100;

        // Ensure the time is formatted as HH:mm
        return `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };
    const ref = useRef<HTMLDivElement>(null);
    const reactToPrintContent = () => {
        return printComponent(ref.current?.cloneNode(true), true);
    };

    const handlePrint = useReactToPrint({});
    const getActionId = (action: number): string => {
        if (action == 1) {
            return deleteActionConfirmationcalloutTargetId;
        } else if (action == 2) {
            return activityActionConfirmationcalloutTargetId;
        } else {
            return ""
        }
    }


    useEffect(() => {
        req = new GetCurrencyPairRequest();
        var l = searchParams.get('org');
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {

            }
        }
        const page = getPage(key)
        dispatch(setTitle(t(normalizeKey(page?.title))));
        dispatch(setPage(page));

        if (id) {
            req.setId(id)
            getPromise = dispatch(get({ body: req, headers: getHeaders() }))
            getPromise.unwrap().then((e: any) => {
                if (hash == "#logs") {
                    setSelectedKey("1");
                } else {
                    setSelectedKey("0");
                }
            });

        } else {
            navigate(-1)
        }


        return () => { //clean up
            getPromise?.abort();
            actionPromise?.abort();
            dispatch(reset());
        }
    }, [])



    const _selectionItems: ICommandBarItemProps[] = [
        {
            key: 'back',
            text: t('back'),
            title: t('back'),
            iconProps: { iconName: 'back' },
            disabled: state.isLoading,
            onClick: () => {
                navigate(-1)
            }
        },
        {
            key: 'refresh',
            text: t('refresh'),
            title: t('refresh'),
            iconProps: { iconName: 'refresh' },
            disabled: state.isLoading,
            onClick: () => {
                dispatch(resetItem())
                getPromise = dispatch(get({ body: req, headers: getHeaders() }))
            }
        },


        {
            key: 'edit',
            text: t("edit"),
            title: t("edit"),
            iconProps: { iconName: 'EditSolid12' },
            subMenuProps: {
                items: [{
                    key: 'editInfo',
                    text: t('edit'),
                    title: t("edit"),
                    iconProps: { iconName: 'EditContact', styles: { root: { fontWeight: "bold" } } },

                    onClick: () => {
                        if (!state.isChangeStateLoading) {
                            setCurrenctAction(101)
                        }

                    }
                },
                {
                    key: 'editPrice',
                    text: t("editPrices"),
                    title: t("editPrices"),
                    iconProps: { iconName: 'Money', styles: { root: { fontWeight: "bold" } } },
                    onClick: () => {
                        if (!state.isChangeStateLoading) {
                            setCurrenctAction(102)
                        }
                    }
                },
                {
                    key: 'linkPair',
                    text: t("linkPair"),
                    title: t("linkPair"),
                    iconProps: { iconName: 'Link', styles: { root: { fontWeight: "bold" } } },
                    onClick: () => {
                        if (!state.isChangeStateLoading) {
                            setCurrenctAction(103)
                        }
                    }
                }

                ]
            },

        },
        {
            key: 'status',
            text: (state.item?.isActive) ? t("deactivate") : t("activate"),
            title: (state.item?.isActive) ? t("deactivate") : t("activate"),
            iconProps: { id: activityActionConfirmationcalloutTargetId, iconName: (state.item?.isActive) ? "Cancel" : "Accept", styles: { root: { fontWeight: (state.item?.isActive) ? undefined : "bold" } } },

            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 2 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 2 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 2 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(2)
                    toggleisActionConfirmationCalloutVisible()
                }
            }
        },
        {
            key: 'delete',
            text: t("delete"),
            title: t("delete"),
            iconProps: { id: deleteActionConfirmationcalloutTargetId, iconName: "Delete", styles: { root: { fontWeight: "bold" } } },

            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 1 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 1 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 1 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(1)
                    toggleisActionConfirmationCalloutVisible()
                }
            }
        },

        {
            key: 'tradingScreen',
            text: t("tradingScreen"),
            iconProps: { iconName: "chart" },
            title: t("tradingScreen"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/chart/?symbol=" + state.item?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },
        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.item?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },
        {
            key: 'share',
            text: t("share"),
            title: t("share"),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },
        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    handlePrint(reactToPrintContent);
                }
            }
        },
    ];



    return (
        <Stack >
            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }

            <Popup isOpen={(currentAction == 101)} title={t("edit")} onDismiss={() => { setCurrenctAction(0) }} >
                <CurrencyPairsForm childrenGap={10} maxWidth={480} type={FormType.EDIT} renderObject={state.item} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateItem(e))
                }} onCancel={() => { setCurrenctAction(0) }} />
            </Popup>

            <Popup isOpen={(currentAction == 102)} title={t("editPrices")} onDismiss={() => { setCurrenctAction(0) }} >
                <CurrencyPairsPriceForm childrenGap={10} maxWidth={480} type={FormType.EDIT} renderObject={state.item} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateItem(e))
                }} onCancel={() => { setCurrenctAction(0) }} />
            </Popup>

            <Popup isOpen={(currentAction == 103)} title={t("linkPair")} isBlocking onDismiss={() => { setCurrenctAction(0) }} >
                <CurrencyPairsPriceSettingsForm childrenGap={10} maxWidth={480} type={FormType.EDIT} renderObject={state.item} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateItem(e))
                }} onCancel={() => { setCurrenctAction(0) }} />
            </Popup>
            {isShareCalloutVisible ? (
                <Callout
                    ariaLabelledBy={shareCalloutLabelId}
                    target={`#${shareTargetId}`}
                    onDismiss={toggleisShareCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <ShareBox onDismiss={toggleisShareCalloutVisible} title={t("shareCurrencyPair")} value={`https://${window.location.host}/currency-pairs/${state.item?.id}` + ((org == -1) ? "" : "?org=" + org)}></ShareBox>
                </Callout>
            ) : null}



            {isActionConfirmationCalloutVisible ? (
                <Callout
                    ariaLabelledBy={ActionConfirmationLabelId}
                    target={`#${getActionId(currentAction)}`}
                    onDismiss={toggleisActionConfirmationCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <Stack tokens={{ padding: '20px 24px ' }}>
                        <Text block variant="xLarge" styles={{ root: { marginBottom: 12 } }}>
                            {(currentAction == 1 ? t("delete") : currentAction == 2 ? (state.item?.isActive) ? t("deactivate") : t("activate") : "")}
                        </Text>
                        <Text block variant="small">
                            {(currentAction == 1 ? t("deleteFeeDesc") : currentAction == 2 ? (state.item?.isActive) ? t("deactivateCurrencyPairDesc") : t("activateCurrencyPairDesc") : "")}
                        </Text>
                        {/* This FocusZone allows the user to go between buttons with the arrow keys.
              It's not related to or required for FocusTrapCallout's built-in focus trapping. */}
                        <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                            <Stack reversed tokens={{ childrenGap: 8, padding: "20px 0px 0px 0px" }} horizontal>
                                <DefaultButton autoFocus onClick={toggleisActionConfirmationCalloutVisible}>{t("cancel")}</DefaultButton>

                                <PrimaryButton onClick={() => {
                                    toggleisActionConfirmationCalloutVisible()
                                    if (state.item) {
                                        if (currentAction == 1) {
                                            let req = new DeleteCurrencyPairRequest();
                                            req.setId(state.item?.id)
                                            actionPromise?.abort();
                                            actionPromise = dispatch(deleteItem({ body: req, headers: getHeaders() }))
                                            actionPromise.unwrap().then((e: any) => {
                                                navigate(-1)
                                            })
                                        } else if (currentAction == 2) {
                                            let req = new UpdateCurrencyPairActivityRequest();
                                            req.setId(state.item?.id)
                                            req.setIsactive(!state.item?.isActive)
                                            actionPromise?.abort();
                                            actionPromise = dispatch(updateStatus({ body: req, headers: getHeaders() }))


                                        }
                                    }
                                }} text={(currentAction == 1 ? t("delete") : currentAction == 2 ? (state.item?.isActive) ? t("deactivate") : t("activate") : "")}  >

                                </PrimaryButton>
                            </Stack>
                        </FocusZone>
                    </Stack>
                </Callout>
            ) : null}

            {state.isLoading ? <ProgressIndicator /> :

                !state.item ? null :
                    <Pivot selectedKey={String(selectedKey)} onLinkClick={(i) => {

                        if (i?.props.itemKey == "1")
                            // navigate("#rules")
                            window.history.replaceState(null, "", "#logs")

                        if (i?.props.itemKey == "0")
                            window.history.replaceState(null, "", "#info")
                        //navigate("#info")

                        setSelectedKey(i?.props?.itemKey ?? "0")
                    }} >
                        <PivotItem headerText={t("info")} itemKey="0"   >
                            <div ref={ref}>
                                <CommandBar
                                    items={_selectionItems}
                                />
                                <Stack tokens={{ childrenGap: 10, padding: "0px 33% 10px 3%" }}>
                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <TextView label={t("id")} value={state.item?.id} />


                                        <TextView label={t("createdDate")} value={state.item?.createdDate} />

                                        {state.item?.addedBy ? <ProfileView label={t("addedBy")} value={state.item?.addedBy == "" ? state.item?.addedById : state.item?.addedBy}
                                            url={"/management/users/" + state.item?.addedById + ((org == -1) ? "" : "?org=" + org)}
                                            text={state.item?.addedBy == "" ? state.item?.addedById : state.item?.addedBy}
                                            imageUrl={PROFILE_LOGO_URL + "/" + getSession()?.organization?.id + "/" + state.item?.addedById + "/profile.jpg"}

                                            size={PersonaSize.size40} />

                                            : undefined}

                                    </Stack>

                                    <ProfileView label={t("pairName")} value={state.item?.name == "" ? state.item?.id : state.item?.name}
                                        url={"#"}
                                        text={state.item?.name == "" ? state.item?.id : state.item?.name}
                                        secondaryText={(state.item?.baseCurrencyCode == "" ? state.item?.baseCurrencyId : state.item?.baseCurrencyCode) + "-" + (state.item?.quoteCurrencyCode == "" ? state.item?.quoteCurrencyId : state.item?.quoteCurrencyCode)}
                                        imageInitials={state.item?.baseCurrencySymbol + "/" + state.item?.quoteCurrencySymbol}
                                        imageUrl={state.item?.iconSource}
                                        tertiaryText={state.item?.categoryNameAr + " | " + state.item?.categoryNameEn}
                                        size={PersonaSize.size40} />

                                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                                        <LinkView label={t("infoURL")} value={state.item?.infoURL == "" ? undefined : state.item?.infoURL}
                                            onLinkClick={() => {
                                                window.open(state.item?.infoURL, '_blank');
                                            }} url={state.item?.infoURL} />


                                        <LinkView label={t("category")} value={state.item?.categoryId != "" ? state.item?.categoryNameAr + " | " + state.item?.categoryNameEn : ""}
                                            url={"/categories/" + state.item?.categoryId + ((org == -1) ? "" : "?org=" + org)} />
                                    </Stack>
                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <LinkView label={t("baseCurrency")} value={state.item?.baseCurrencyName == "" ? state.item?.baseCurrencyId : state.item?.baseCurrencyName}
                                            url={"/currencies/" + state.item?.baseCurrencyId + ((org == -1) ? "" : "?org=" + org)} />

                                        <LinkView label={t("quoteCurrency")} value={state.item?.quoteCurrencyName == "" ? state.item?.quoteCurrencyId : state.item?.quoteCurrencyName}
                                            url={"/currencies/" + state.item?.quoteCurrencyId + ((org == -1) ? "" : "?org=" + org)} />

                                        <TextView label={t("status")} iconName={state.item?.isActive != undefined ? state.item?.isActive ? "Accept" : "Cancel" : undefined} value={state.item?.isActive != undefined ? state.item?.isActive ? t("active") : t("inactive") : ""} />

                                        <TextView label={t("syncPrices")} iconName={state.item?.syncPrices != undefined ? state.item?.syncPrices ? "Accept" : "Cancel" : undefined} value={state.item?.syncPrices != undefined ? state.item?.syncPrices ? t("active") : t("inactive") : ""} />


                                    </Stack>
                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <TextView label={t("isMatchingEngineEnabled")} iconName={state.item?.isMatchingEngineEnabled != undefined ? state.item?.isMatchingEngineEnabled ? "Accept" : "Cancel" : undefined} value={state.item?.isMatchingEngineEnabled != undefined ? state.item?.isMatchingEngineEnabled ? t("active") : t("inactive") : ""} />

                                        <TextView label={t("canPlaceOrders")} iconName={state.item?.canPlaceOrders != undefined ? state.item?.canPlaceOrders ? "Accept" : "Cancel" : undefined} value={state.item?.canPlaceOrders != undefined ? state.item?.canPlaceOrders ? t("active") : t("inactive") : ""} />

                                        <TextView label={t("canClientCancelOrder")} iconName={state.item?.canClientCancelOrders != undefined ? state.item?.canClientCancelOrders ? "Accept" : "Cancel" : undefined} value={state.item?.canClientCancelOrders != undefined ? state.item?.canClientCancelOrders ? t("enabled") : t("disabled") : ""} />
                                    </Stack>
                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <TextView label={t("buyPrice")} value={state.item?.buyPrice ? currencyFormatter(state.item?.buyPrice, { significantDigits: state.item?.quoteCurrencyDecimalPlaces ?? 9, symbol: state.item?.quoteCurrencySymbol }) : ""} />

                                        <TextView label={t("sellPrice")} value={state.item?.sellPrice ? currencyFormatter(state.item?.sellPrice, { significantDigits: state.item?.quoteCurrencyDecimalPlaces ?? 9, symbol: state.item?.quoteCurrencySymbol }) : ""} />

                                        <TextView label={t("tradingPrice")} value={state.item?.tradingPrice ? currencyFormatter(state.item?.tradingPrice, { significantDigits: state.item?.quoteCurrencyDecimalPlaces ?? 9, symbol: state.item?.quoteCurrencySymbol }) : ""} />


                                    </Stack>

                                    <Stack horizontal tokens={{ childrenGap: 10 }}>


                                        <TextView label={t("latestUpdateDate")} value={state.item?.priceUpdate ? state.item?.priceUpdate : undefined} />


                                    </Stack>

                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <TextView label={t("priceMinLimit")} value={state.item?.priceMinLimit ? state.item?.isPriceLimitPercentage ? currencyFormatter(state.item?.priceMinLimit, { significantDigits: 2, symbol: "%" }) : currencyFormatter(state.item?.priceMinLimit, { significantDigits: state.item?.quoteCurrencyDecimalPlaces ?? 9, symbol: state.item?.quoteCurrencySymbol }) : ""} />

                                        <TextView label={t("priceMaxLimit")} value={state.item?.priceMaxLimit ? state.item?.isPriceLimitPercentage ? currencyFormatter(state.item?.priceMaxLimit, { significantDigits: 2, symbol: "%" }) : currencyFormatter(state.item?.priceMaxLimit, { significantDigits: state.item?.quoteCurrencyDecimalPlaces ?? 9, symbol: state.item?.quoteCurrencySymbol }) : ""} />

                                        <TextView label={t("priceTickSize")} value={state.item?.priceTickSize ? currencyFormatter(state.item?.priceTickSize, { significantDigits: state.item?.quoteCurrencyDecimalPlaces ?? 9, symbol: state.item?.quoteCurrencySymbol }) : ""} />

                                    </Stack>

                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <TextView label={t("quantityMinLimit")} value={state.item?.quantityMinLimit ? currencyFormatter(state.item?.quantityMinLimit, { significantDigits: state.item?.baseCurrencyDecimalPlaces ?? 9, symbol: state.item?.baseCurrencySymbol }) : ""} />

                                        <TextView label={t("quantityMaxLimit")} value={state.item?.quantityMaxLimit ? currencyFormatter(state.item?.quantityMaxLimit, { significantDigits: state.item?.baseCurrencyDecimalPlaces ?? 9, symbol: state.item?.baseCurrencySymbol }) : ""} />

                                        <TextView label={t("quantityTickSize")} value={state.item?.quantityTickSize ? currencyFormatter(state.item?.quantityTickSize, { significantDigits: state.item?.baseCurrencyDecimalPlaces ?? 9, symbol: state.item?.baseCurrencySymbol }) : ""} />

                                    </Stack>


                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <TextView label={t("tradingDays")} value={state.item?.tradingDays && state.item?.tradingDays.length == 7 ? [{ key: 0, text: t("sunday") }, { key: 1, text: t("monday") }, { key: 2, text: t("tuesday") }
                                            , { key: 3, text: t("wednesday") }, { key: 4, text: t("thursday") },
                                        { key: 5, text: t("friday") }, { key: 6, text: t("saturday") }


                                        ].filter((day, index) => state.item?.tradingDays[index])
                                            .map(day => day.text)
                                            .join(', ') : undefined} />
                                        <TextView label={t("openingDay")} value={[{ key: 0, text: t("sunday") }, { key: 1, text: t("monday") }, { key: 2, text: t("tuesday") }
                                            , { key: 3, text: t("wednesday") }, { key: 4, text: t("thursday") },
                                        { key: 5, text: t("friday") }, { key: 6, text: t("saturday") }

                                        ].filter((day, index) => day.key == state.item?.openingDay)?.at(0)?.text
                                        } />

                                        <TextView label={t("tradingTimes")} value={state.item?.tradingHours && state.item?.tradingHours.length == 2 ? (t("from") + ": " + formatTradingHours(state.item?.tradingHours[0])) + " " + (t("to") + ": " + formatTradingHours(state.item?.tradingHours[1])) : undefined} />


                                    </Stack>

                                    <Separator alignContent="start"><b>{t("linkPairSettings")}</b></Separator>

                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <ProfileView label={t("mainPair")} value={state.item?.mainCurrencyPairName == "" ? state.item?.mainCurrencyPair : state.item?.mainCurrencyPairName}
                                            url={"/currency-pairs/" + state.item?.mainCurrencyPair + ((org == -1) ? "" : "?org=" + org)}
                                            text={state.item?.mainCurrencyPairName == "" ? state.item?.mainCurrencyPair : state.item?.mainCurrencyPairName}
                                            secondaryText={(state.item?.mainCurrencyPairBaseCurrencyCode == "" ? state.item?.mainCurrencyPairBaseCurrencyId : state.item?.mainCurrencyPairBaseCurrencyCode) + "-" + (state.item?.mainCurrencyPairQuoteCurrencyCode == "" ? state.item?.mainCurrencyPairQuoteCurrencyId : state.item?.mainCurrencyPairQuoteCurrencyCode)}
                                            imageInitials={state.item?.mainCurrencyPairBaseCurrencySymbol + "/" + state.item?.mainCurrencyPairQuoteCurrencySymbol}
                                            size={PersonaSize.size40} />


                                        <TextView label={t("status")} iconName={state.item?.isPriceTriggerActive != undefined ? state.item?.isPriceTriggerActive ? "Accept" : "Cancel" : undefined} value={state.item?.isPriceTriggerActive != undefined ? state.item?.isPriceTriggerActive ? t("active") : t("inactive") : ""} />


                                    </Stack>

                                    <Stack horizontal tokens={{ childrenGap: 10 }}>

                                        <TextView label={t("buyPriceEquation")} value={state.item?.buyPriceEquation ? state.item?.buyPriceEquation : undefined} />
                                        <TextView label={t("sellPriceEquation")} value={state.item?.sellPriceEquation ? state.item?.sellPriceEquation : undefined} />
                                        <TextView label={t("tradingPriceEquation")} value={state.item?.tradingPriceEquation ? state.item?.tradingPriceEquation : undefined} />


                                    </Stack>



                                </Stack>
                            </div>
                        </PivotItem>

                        <PivotItem headerText={t("exchangeRates")} itemKey="1"  >
                            <CurrencyPairPriceChangeLogPage currencyPair={state.item} />
                        </PivotItem>


                    </Pivot>


            }



        </Stack>



    );
}




